const CODE_PANEL = {
	ARTICLE_NON_BUDGETAIRE: 'ANB',
	CODE_PRODUIT_LOCAL: 'CPL',
	COMPTE_DE_TIERS: 'CDT',
	COVID: 'COV',
	DELAI_PAIEMENT: 'DEL',
	DETAIL_DE_FACTURATION: 'DDF',
	EDITION_ASAP_DEMATERIALISEE: 'EAD',
	FCTVA: 'FCT',
	INFORMATIONS_CHORUS_PRO: 'ICP',
	INFORMATIONS_RATTACHEMENT: 'RAT',
	INVENTAIRE: 'INV',
	NUMERO_EMPRUNT: 'NEM',
	PERIODE_COUVERTE: 'PCV',
	PROJET: 'PRO',
	REGIE: 'REG',
	ROLE_DE_RECOUVREMENT: 'RDR',
	TRAVAUX_EN_REGIE: 'TER',
	TYPOLOGIE_PES: 'TPE',
} as const;

export default CODE_PANEL;
